import { PianoUser } from "@Quiz/Result/use_pianoid"

export const termsTextHTML = 'Hiermit akzeptiere ich die <a href="#">Teilnahmebedingungen</a> und erkläre mich damit einverstanden, bis auf Widerruf Angebote der Süddeutsche Zeitung GmbH zu erhalten. Infos zum Widerruf und Datenschutz unter <a href="#">www.sz.de/datenschutz</a>. Teilnahmeschluss ist der 22.01.2026, 16:59. Mehrfachteilnahmen werden gelöscht. Die Teilnahme am Gewinnspiel ist kostenlos.'

export const currentRaffleUrl = "https://sz-magazin.de/gewinnen"

export const mockedUser: PianoUser = {
  aud: "___aud",
  confirmed: true,
  email: "mock@email.com",
}
